import Swal from "sweetalert2";
import { isMobile } from 'react-device-detect';

// 타이머 끝나면 사라지는 간단한 알림
export const Toast = Swal.mixin({
    toast: true,
    position: isMobile ? 'top' : `bottom-left`,
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    width: '30rem',
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  // 네, 아니오 선택 알림
  export const YesNo = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-success',
      cancelButton: 'btn btn-danger'
    },
    buttonsStyling: false
  })